import { useObserver } from 'mobx-react';
import useMst from '~/src/hooks/useMst';
import useResourcePagination from '~/src/hooks/useResourcePagination';
import { SortByOrder } from '~/src/hooks/sortByOrder';

const useTemplatesPagination = ({
  clioTemplates,
  practiceArea,
  jurisdiction,
} = {}) => {
  const { templates } = useMst((store) => ({
    templates: store.templates,
  }));

  const fetchWithOptions = (query) => {
    const fetchQuery = { ...query };
    if (clioTemplates) {
      fetchQuery.clioTemplates = clioTemplates;
    }
    if (practiceArea) {
      fetchQuery.practiceArea = practiceArea;
    }
    if (jurisdiction) {
      fetchQuery.jurisdiction = jurisdiction;
    }
    return templates.fetch(fetchQuery);
  };
  const {
    loading,
    next,
    page,
    empty,
    setSearch,
    done,
    setSortBy,
    setOrder,
    reload,
  } = useResourcePagination({
    fetch: fetchWithOptions,
    limit: 10,
    order: SortByOrder.desc,
  });

  const listData = useObserver(() => {
    return templates.list.flat();
  });

  return {
    next,
    page,
    empty,
    data: listData,
    loading,
    done,

    setSearch,
    setSortBy,
    setOrder,
    reload,
  };
};

export default useTemplatesPagination;
